import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import ReconocimientoStockView from '../../../components/listados/movimientosTerminal/ReconocimientoStockView'
import StockPresuntoTerminalView from '../../../components/listados/movimientosTerminal/StockPresuntoTerminalView'
import { obtenerReconocimientoStock, obtenerStockPresuntoTerminal } from '../../../actions/listados'

function ReconocimientoStock (props) {
  const { obtenerReconocimientoStock, obtenerStockPresuntoTerminal } = props

  useEffect(() => {
    obtenerReconocimientoStock()
    obtenerStockPresuntoTerminal()
  }, [obtenerReconocimientoStock, obtenerStockPresuntoTerminal])

  return (
    <>
      {/* Stock presunto */}
      <StockPresuntoTerminalView />

      {/* Ultimos reconocimientos de stock de la Terminal */}
      <ReconocimientoStockView />
    </>
  )
}

const mapActionsToProps = {
  obtenerReconocimientoStock,
  obtenerStockPresuntoTerminal
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(ReconocimientoStock)
